$(document).on('change', 'input[name="costcenter"]', function () {
  const $customerOrderId = $('input[name="customer_order_id"]');
  const $kommission = $(this).val();
  $customerOrderId.val($kommission);
});

$(document).on('click', 'a[data-add-costcenter]', (event) => {
  event.preventDefault();
  $.ajax({
    method: 'GET',
    url: $(event.target).attr('href'),
  }).done((resp) => {
    const element = $(resp).appendTo($('body'));
    element.foundation().foundation('open');
  });
});

$(document).on('click', 'a[data-checkout-create-costcenter]', (event) => {
  console.log('clicked');
  event.preventDefault();
  const $triger = $(event.target);
  console.log($triger);
  const $form = $triger.closest('form');
  $form.submit();
});
